// extracted by mini-css-extract-plugin
module.exports = {"block":"FullHighSchoolNews_block__0UYBq","header":"FullHighSchoolNews_header__SS9vI","title":"FullHighSchoolNews_title__bMLLQ"};